<template>
  <v-app>
    <v-container fluid class="fill-height pa-0 screen">
      <v-row no-gutters class="fill-height">
        <v-col cols="12" md="8" class="pa-10 left meeting-main">
          <div class="logo">
            <v-img
              src="@/assets/zaturdaylogobluewithtext.png"
              width="300"
              height="70"
              class="meeting-logo"
              style="margin-left: -2rem"
              @click="handleLogoClick"
            />
          </div>
          <div class="room-title">{{ roomName }}</div>
          <v-divider class="underline"></v-divider>
          <div
            class="status-label"
            :class="!meetingDataReady ? 'unavailable' : currentMeeting ? 'occupied' : 'available'"
          >
            {{ !meetingDataReady ? (lastMeetingSyncAt ? "Out of sync" : isFetchingMeetings ? "Loading" : "Unavailable") : currentMeeting ? "Meeting Now" : "Available" }}
          </div>

          <v-alert
            v-if="!meetingDataReady"
            class="meeting-sync-alert mt-4"
            dense
            outlined
            type="warning"
            role="status"
            aria-live="polite"
          >
            {{ isFetchingMeetings ? "กำลังอัปเดตข้อมูลห้องประชุม…" : meetingLoadError || "ข้อมูลห้องประชุมยังไม่พร้อม กรุณาอัปเดตอีกครั้ง" }}
            <div v-if="lastMeetingSyncAt">Last sync: {{ formatDate(lastMeetingSyncAt) }} {{ format(lastMeetingSyncAt) }}</div>
            <v-btn small text :disabled="isFetchingMeetings" @click="getDataTodayMeetings(true, true)">Retry</v-btn>
          </v-alert>

          <div v-if="currentMeeting">
            <div class="current-meeting-time">
              {{ format(currentMeeting?.start) }} -
              {{ format(currentMeeting?.end) }}
            </div>

            <div class="current-meeting-title">
              {{ currentMeeting?.title }}
            </div>

            <div class="current-meeting-organizer">
              {{ currentMeeting?.organizer }}
            </div>
            <div
              class="mt-8 action-buttons"
              v-if="meetingDataReady && currentMeeting.checkInStatus == false"
            >
              <v-btn
                x-large
                class="btn-checkin"
                @click="OpenCheckinDialog(currentMeeting)"
                >Check in</v-btn
              >
              <v-btn
                x-large
                class="btn-release"
                :loading="LoadingDialog"
                :disabled="LoadingDialog"
                @click="endAndReleaseMeeting(currentMeeting)"
              >
                End & Release
              </v-btn>
            </div>
            <div class="mt-8 meeting-actions" v-else-if="meetingDataReady">
              <div class="action-buttons">
                <v-btn
                  x-large
                  class="btn-checkout"
                  @click="openCheckOutDialog(currentMeeting)"
                  >Check Out</v-btn
                >
                <v-btn x-large class="btn-extend" @click="openExtendDialog()"
                  ><v-icon size="25" color="black" class="mr-3"
                    >mdi-plus-circle</v-icon
                  >Extend</v-btn
                >
              </div>
              <div class="order-button-row">
                <button class="btn-order" type="button" @click="openOrder()">
                  <span class="order-icon-wrap">
                    <v-img
                      src="@/assets/icons/cup.png"
                      width="34"
                      height="34"
                      contain
                      class="order-icon"
                    />
                  </span>
                  <span class="order-text">Order</span>
                </button>
              </div>
            </div>
          </div>
        </v-col>

        <v-col cols="12" md="4" class="meeting-sidebar">
          <div class="right-panel pa-6">
            <div class="clock-section text-center">
              <div class="clock-time" @click="ReloadPage()">{{ time }}</div>
              <div class="clock-date">{{ date }}</div>
            </div>
            <div class="next-title mt-10">
              <span>
                <v-img
                  src="@/assets/icons/Triangle.png"
                  width="35"
                  height="35"
                />
              </span>
              <span class="ml-3">NEXT MEETING</span>
            </div>
            <div class="mt-2 meeting-list">
              <div class="meeting-card-list">
                <v-card
                  v-for="(item, i) in panelMeetings || []"
                  :key="item.eventID || item.id || i"
                  class="meeting-card mb-3"
                  :class="{
                    active: isCurrentMeeting(item),
                    'checked-out': isCheckedOutMeeting(item),
                  }"
                  elevation="0"
                >
                  <div v-if="isCheckedOutMeeting(item)" class="meeting-badge">
                    Checked out
                  </div>
                  <div class="meeting-time">
                    {{ item?.start ? format(item.start) : "" }} –
                    {{ item?.end ? format(item.end) : "" }}
                  </div>

                  <div class="meeting-title">
                    {{ item.title }}
                  </div>

                  <div class="meeting-organizer">
                    {{ getMeetingOrganizer(item) }}
                  </div>
                </v-card>
              </div>
              <div class="booking-button-group">
                <v-btn block x-large class="book-btn" :disabled="!meetingDataReady" @click="ReserveRoom()">
                  Book Now
                </v-btn>
                <v-btn
                  block
                  x-large
                  class="all-booking-btn mt-3"
                  @click="openAllBooking()"
                >
                  All Booking
                </v-btn>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="NewBookingDialog" max-width="1200" persistent>
      <v-card class="booking-wrapper booking-form-wrapper">
        <v-container class="booking-container">
          <div class="booking-header">{{ roomName }}</div>
          <div class="booking-clock">
            <div
              class="booking-time"
              :class="{ 'future-booking-date': !isBookingToday }"
            >
              {{ isBookingToday ? bookingDisplayTime : bookingDisplayDate }}
            </div>
            <div v-if="isBookingToday" class="booking-date">
              {{ bookingDisplayDate }}
            </div>
          </div>
          <v-alert v-if="bookingDateExpired" dense outlined type="warning" role="status">
            วันที่จองผ่านไปแล้ว กรุณาปิดฟอร์มและเลือกวันที่จองใหม่
          </v-alert>
          <v-row dense class="mb-6">
            <v-col cols="12" md="6">
              <div class="booking-pill-wrapper">
                <span class="booking-label">Meeting Name :</span>
                <v-text-field
                  v-model="title"
                  solo
                  flat
                  dense
                  hide-details
                  class="booking-pill-input"
                />
              </div>
            </v-col>

            <v-col cols="12" md="6">
              <div class="booking-pill-wrapper">
                <span class="booking-label">Host Name :</span>
                <v-text-field
                  v-model="organizer"
                  solo
                  flat
                  dense
                  disabled
                  hide-details
                  class="booking-pill-input"
                />
              </div>
            </v-col>
          </v-row>

          <v-card class="booking-time-card" flat>
            <v-row align="center">
              <v-col cols="12" md="6" class="d-flex justify-center">
                <div class="time-row">
                  <span size="29" class="booking-label">Start Time :</span>
                  <date-picker
                    v-model="StartTime"
                    type="time"
                    format="HH:mm"
                    value-type="format"
                    :minute-step="1"
                    :show-second="false"
                    :editable="false"
                    :clearable="false"
                    :open.sync="startTimePickerOpen"
                    :disabled-time="isStartTimeDisabled"
                    :input-attr="{ 'aria-label': 'Start Time' }"
                    :popup-style="{ width: '360px' }"
                    class="booking-time-picker"
                    input-class="booking-time-picker-input"
                    popup-class="booking-time-picker-popup"
                    @change="handleStartTimePickerChange"
                  />
                </div>
              </v-col>

              <v-col cols="12" md="6" class="d-flex justify-center">
                <div class="time-row">
                  <span class="booking-label">To :</span>
                  <date-picker
                    v-model="EndTime"
                    type="time"
                    format="HH:mm"
                    value-type="format"
                    :minute-step="1"
                    :show-second="false"
                    :editable="false"
                    :clearable="false"
                    :open.sync="endTimePickerOpen"
                    :disabled-time="isEndTimeDisabled"
                    :input-attr="{ 'aria-label': 'End Time' }"
                    :popup-style="{ width: '360px' }"
                    class="booking-time-picker"
                    input-class="booking-time-picker-input"
                    popup-class="booking-time-picker-popup"
                    @change="handleEndTimePickerChange"
                  />
                </div>
              </v-col>
            </v-row>

            <div class="duration-wrapper">
              <div class="duration-pill">
                Duration :
                <strong>{{ durationHour }}</strong> Hour
                <strong>{{ durationMinute }}</strong> Min
              </div>
            </div>
          </v-card>
        </v-container>

        <v-card-actions class="booking-actions">
          <v-btn
            x-large
            class="cancel-btn"
            :disabled="bookingSubmitting"
            @click="NewBookingDialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            x-large
            class="confirm-btn"
            :loading="bookingSubmitting"
            :disabled="bookingSubmitting || !title.trim() || !meetingDataReady || bookingDateExpired"
            @click="createBooking()"
          >
            Book a Meeting
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="SuccessNewBookingDialog" max-width="720px" persistent>
      <v-card class="booking-wrapper success-booking-wrapper">
        <v-card class="success-booking-card">
          <div class="success-wrapper success-booking-content">
            <div class="success-icon success-booking-icon">
              <v-icon size="54" color="white">mdi-check</v-icon>
            </div>
            <div class="success-title success-booking-title">
              Your Booking Is Successful
            </div>
            <div class="success-info success-booking-info">
              <div class="info-row success-booking-row">
                <span>Date</span>
                <span>:</span>
                <span>{{ bookingDate }}</span>
              </div>
              <div class="info-row success-booking-row">
                <span>Time</span>
                <span>:</span>
                <span>{{ bookingTime }}</span>
              </div>
              <div class="info-row success-booking-row">
                <span>Room</span>
                <span>:</span>
                <span>{{ roomName }}</span>
              </div>
            </div>
          </div>
        </v-card>
      </v-card>
    </v-dialog>

    <v-dialog v-model="CheckinDialog" max-width="650px" he persistent>
      <v-card class="booking-wrapper">
        <v-card class="pt-5 pb-5">
          <div class="success-wrapper">
            <div class="success-title">Check In</div>
            <div class="mt-3">
              <qrcode-vue :value="QRData" size="150" level="M" />
            </div>
            <div class="success-info">
              <p
                style="
                  font-size: 28px;
                  font-weight: 700;
                  color: #0f3f8c;
                  text-align: center;
                "
              >
                {{ bookingName }}
              </p>
              <div class="info-row">
                <span>Date</span>
                <span>:</span>
                <span style="text-align: center">{{ bookingDate }}</span>
              </div>
              <div class="info-row">
                <span>Time</span>
                <span>:</span>
                <span style="text-align: center">{{ bookingTime }}</span>
              </div>
              <div class="info-row">
                <span>Room</span>
                <span>:</span>
                <span style="text-align: center">{{ roomName }}</span>
              </div>
            </div>
          </div>
          <v-row class="mt-3">
            <v-col cols="12" md="12" align="center">
              <v-btn x-large class="btn-release" @click="CheckinDialog = false"
                >Close</v-btn
              >
            </v-col>
          </v-row>
        </v-card>
      </v-card>
    </v-dialog>

    <v-dialog v-model="ExtendDialog" max-width="770" persistent>
      <v-card class="extend-wrapper">
        <v-row class="extend-icon-wrapper">
          <div>
            <v-img width="90" height="90" src="@/assets/icons/clock.png" />
          </div>
        </v-row>
        <div class="extend-title">Extend this meeting?</div>
        <div class="extend-current">
          Current :
          <span
            >{{ format(currentMeeting?.start) }} -
            {{ format(currentMeeting?.end) }}</span
          >
        </div>
        <div class="extend-new">
          Extended: <span>{{ ExtendStartTime }} - {{ ExtendExpireTime }}</span>
        </div>
        <v-row class="extend-options" justify="center">
          <v-col cols="4" v-for="min in extendOptions" :key="min">
            <div
              class="extend-card"
              :class="{
                active: selectedExtend === min,
                disabled: !canExtend(min),
              }"
              @click="canExtend(min) && selectExtend(min)"
            >
              <div class="extend-number">{{ min }}</div>
              <div class="extend-text">Min</div>
            </div>
          </v-col>
        </v-row>
        <div class="extend-actions">
          <v-btn class="btn-cancel" x-large @click="ExtendDialog = false"
            >Cancel</v-btn
          >
          <v-btn
            color="#00378E"
            class="btn-confirm"
            x-large
            :disabled="!selectedExtend || LoadingDialog"
            :loading="LoadingDialog"
            @click="confirmExtend()"
          >
            Confirm
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="CheckOutDialog" max-width="720px" persistent>
      <v-card class="checkout-panel">
        <div class="checkout-header">
          <div class="checkout-icon">
            <v-icon size="36" color="white">mdi-clock-check-outline</v-icon>
          </div>
          <div class="checkout-heading">
            <div class="checkout-kicker">End meeting</div>
            <div class="checkout-title">Check Out</div>
          </div>
          <v-spacer></v-spacer>
          <v-btn icon class="checkout-close" @click="CheckOutDialog = false">
            <v-icon color="#9a0003">mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-text class="checkout-body">
          <div class="checkout-time-strip">
            <div>
              <div class="checkout-label">Now</div>
              <div class="checkout-now">{{ time }}</div>
            </div>
            <div class="checkout-status-pill">Ready to release</div>
          </div>
          <v-container class="checkout-content">
            <v-row dense class="checkout-detail-grid">
              <v-col cols="12" md="6" class="checkout-detail-card">
                <p style="font-size: 18px">
                  <b style="color: black">Booking Name :</b>
                  {{ currentMeeting?.title }}
                </p>
                <p style="font-size: 18px">
                  <b style="color: black">Date/Time :</b>
                  {{ format(currentMeeting?.start) }} –
                  {{ format(currentMeeting?.end) }}
                </p>
              </v-col>
              <v-col cols="12" md="6" class="checkout-detail-card">
                <p style="font-size: 18px">
                  <b style="color: black">Room :</b> {{ roomName }}
                </p>
                <p style="font-size: 18px">
                  <b style="color: black">HostName :</b>
                  {{ currentMeeting?.organizer }}
                </p>
              </v-col>
            </v-row>
            <v-text-field
              v-if="checkoutRequiresOtp"
              :value="checkoutOtp"
              label="Check-out OTP"
              hint="Enter the same 6-digit OTP emailed to the meeting organizer for check-in."
              persistent-hint
              type="password"
              inputmode="numeric"
              maxlength="6"
              autocomplete="off"
              outlined
              class="mt-4"
              :disabled="LoadingDialog"
              @input="updateCheckoutOtp"
            />
            <v-row dense justify="center" class="checkout-actions">
              <v-col cols="12" md="10" class="d-flex justify-center">
                <v-btn
                  x-large
                  class="checkout-cancel-btn"
                  @click="CheckOutDialog = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  x-large
                  class="checkout-confirm-btn"
                  :loading="LoadingDialog"
                  :disabled="LoadingDialog || (checkoutRequiresOtp && checkoutOtp.length !== 6)"
                  @click="checkOutMeeting(currentMeeting)"
                >
                  Check Out
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="SuccessCheckOutDialog" max-width="650px" he persistent>
      <v-card class="booking-wrapper">
        <v-card class="pt-5 pb-5">
          <div class="success-wrapper">
            <div class="success-icon">
              <v-icon size="46" color="white">mdi-check</v-icon>
            </div>
            <div class="success-title">Check Out Successful</div>
          </div>
        </v-card>
      </v-card>
    </v-dialog>

    <v-dialog :value="LoadingDialog || meetingsLoading" persistent width="auto">
      <v-card
        class="pa-6 d-flex flex-column align-center justify-center"
        elevation="8"
        rounded="xl"
      >
        <v-progress-circular
          indeterminate
          color="indigo"
          size="70"
          width="6"
        ></v-progress-circular>
        <span class="mt-4 text-subtitle-1 font-weight-medium"
          >Loading, please wait...</span
        >
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import axios from "axios";
import dayjs from "dayjs";
import enurl from "@/api/environment";
import Swal from "sweetalert2/dist/sweetalert2.js";
import QrcodeVue from "qrcode.vue";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { prefetchBeverageMenu } from "@/utils/beverageMenuCache";

const ACTION_INACTIVITY_TIMEOUT_MS = 60 * 1000;
const PAD_READ_TIMEOUT_MS = 30000;
const MEETING_DATA_MAX_AGE_MS = 45000;

export default {
  name: "MeetingRoomScreen",
  components: {
    QrcodeVue,
    DatePicker,
  },
  data() {
    return {
      url: enurl.apiUrl,
      LoadingDialog: false,
      bookingSubmitting: false,
      roomName: "",
      available: true,
      time: "",
      date: "",
      now: dayjs(),
      loading: false,
      reservations: [],
      checkoutHistories: [],
      isFetchingMeetings: false,
      meetingsLoading: false,
      meetingLoadError: "",
      lastMeetingSyncAt: null,
      meetingDataVersion: 0,
      meetingDataStale: false,
      clockInterval: null,
      meetingRefreshInterval: null,
      meetingRefreshFailures: 0,
      checkoutSuccessTimeout: null,
      bookingSuccessTimeout: null,
      actionInactivityTimer: null,
      logoClickCount: 0,
      logoClickTimeout: null,

      NewBookingDialog: false,
      SuccessNewBookingDialog: false,
      CheckinDialog: false,
      ExtendDialog: false,
      CheckOutDialog: false,
      checkoutOtp: "",
      checkoutEventID: "",
      SuccessCheckOutDialog: false,
      duration: 30,
      title: "",
      hostName: "",
      organizer: "",
      QRData: "",

      StartDate: dayjs().format("YYYY-MM-DD"),
      EndDate: dayjs().format("YYYY-MM-DD"),
      StartTime: "",
      EndTime: "",
      startTimePickerOpen: false,
      endTimePickerOpen: false,
      timeOptions: [],
      bookingTimeReference: null,
      bookingID: null,
      bookingEventID: "",
      bookingDate: "",
      bookingTime: "",
      bookingName: "",

      extendOptions: [15, 30, 60],
      selectedExtend: null,
      extendEventID: "",
      ExtendStartTime: "",
      ExtendExpireTime: "",
    };
  },

  async mounted() {
    let self = this;
    window.addEventListener("keydown", self.preventPageZoomKeydown, true);
    window.addEventListener("wheel", self.preventPageZoomWheel, {
      passive: false,
      capture: true,
    });
    document.addEventListener("touchmove", self.preventPagePinchZoom, {
      passive: false,
    });
    document.addEventListener("gesturestart", self.preventPageZoomGesture);
    document.addEventListener("gesturechange", self.preventPageZoomGesture);
    ["touchstart", "mousedown", "keydown", "wheel", "scroll"].forEach((eventName) => {
      window.addEventListener(eventName, self.resetActionInactivityTimer, true);
    });
    self.updateClock();
    if (!document.hidden) self.clockInterval = setInterval(self.updateClock, 1000);
    document.addEventListener("visibilitychange", self.handleMeetingVisibilityChange);
    await Promise.all([self.getDataUserPad(), self.getDataTodayMeetings()]);
    if (!self._isDestroyed) {
      self.openBookingFromRoute();
    }
  },

  beforeDestroy() {
    window.removeEventListener("keydown", this.preventPageZoomKeydown, true);
    window.removeEventListener("wheel", this.preventPageZoomWheel, true);
    document.removeEventListener("touchmove", this.preventPagePinchZoom);
    document.removeEventListener("gesturestart", this.preventPageZoomGesture);
    document.removeEventListener("gesturechange", this.preventPageZoomGesture);
    ["touchstart", "mousedown", "keydown", "wheel", "scroll"].forEach((eventName) => {
      window.removeEventListener(eventName, this.resetActionInactivityTimer, true);
    });
    clearInterval(this.clockInterval);
    document.removeEventListener("visibilitychange", this.handleMeetingVisibilityChange);
    clearTimeout(this.meetingRefreshInterval);
    clearTimeout(this.logoClickTimeout);
    clearTimeout(this.checkoutSuccessTimeout);
    clearTimeout(this.bookingSuccessTimeout);
    clearTimeout(this.actionInactivityTimer);
  },

  created() {
    this._meetingFetchPromise = null;
    this._queuedMeetingRefresh = null;
    const times = [];
    for (let h = 0; h < 24; h++) {
      for (let m = 0; m < 60; m++) {
        times.push(
          `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`
        );
      }
    }
    this.timeOptions = times;
  },

  watch: {
    CheckOutDialog(isOpen) {
      if (!isOpen) {
        this.checkoutOtp = "";
        this.checkoutEventID = "";
      }
      this.resetActionInactivityTimer();
    },

    currentMeeting(meeting, previousMeeting) {
      const pollingModeChanged =
        meeting?.eventID !== previousMeeting?.eventID ||
        meeting?.checkInStatus !== previousMeeting?.checkInStatus;
      if (pollingModeChanged && !this._meetingFetchPromise) this.scheduleMeetingRefresh();
      if (this.CheckinDialog && (meeting?.eventID !== this.bookingEventID || meeting?.checkInStatus === true)) {
        this.CheckinDialog = false;
      }
      if (this.CheckOutDialog && meeting?.eventID !== this.checkoutEventID) {
        this.CheckOutDialog = false;
      }
      if (this.ExtendDialog && meeting?.eventID !== this.extendEventID) {
        this.ExtendDialog = false;
      }
    },

    ExtendDialog(isOpen) {
      if (!isOpen) {
        this.extendEventID = "";
        this.selectedExtend = null;
        this.ExtendStartTime = "";
        this.ExtendExpireTime = "";
      }
      this.resetActionInactivityTimer();
    },

    meetingDataReady(isReady) {
      if (!isReady) {
        this.ExtendDialog = false;
        this.CheckOutDialog = false;
        this.CheckinDialog = false;
      }
    },

    NewBookingDialog(isOpen) {
      if (isOpen) {
        this.updateClock();
        this.syncBookingTimes();
      } else {
        this.startTimePickerOpen = false;
        this.endTimePickerOpen = false;
        this.bookingTimeReference = null;
      }
      this.resetActionInactivityTimer();
    },

    CheckinDialog() {
      this.resetActionInactivityTimer();
    },

    LoadingDialog() {
      this.resetActionInactivityTimer();
    },

    bookingSubmitting(isSubmitting) {
      if (!isSubmitting) {
        this.updateClock();
        this.syncBookingTimes();
      }
      this.resetActionInactivityTimer();
    },

    StartTime(startTime) {
      if (!startTime) {
        return;
      }

      const options = this.endTimeOptions;
      if (options.includes(this.EndTime)) {
        return;
      }

      this.EndTime =
        options[Math.min(Math.max(this.duration - 1, 0), options.length - 1)] ||
        "";
    },

  },

  computed: {
    meetingDataReady() {
      return !!this.lastMeetingSyncAt &&
        !this.meetingLoadError &&
        !this.meetingDataStale &&
        this.now.valueOf() - this.lastMeetingSyncAt <= MEETING_DATA_MAX_AGE_MS;
    },

    checkoutRequiresOtp() {
      return this.currentMeeting?.bookingSource === "ExternalGoogleCalendar";
    },

    isBookingToday() {
      return dayjs(this.StartDate).isSame(dayjs(), "day");
    },

    bookingDateExpired() {
      return dayjs(this.StartDate).isBefore(this.now, "day");
    },

    bookingDisplayTime() {
      return this.time || dayjs().format("HH:mm");
    },

    bookingDisplayDate() {
      const selectedDate = dayjs(this.StartDate);
      if (!selectedDate.isValid()) {
        return this.date;
      }

      return selectedDate.toDate().toLocaleDateString("th-TH", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    },

    startTimeOptions() {
      return this.availableTimeOptions(this.StartDate);
    },

    endTimeOptions() {
      const options = this.availableTimeOptions(this.EndDate);
      if (!this.StartTime) {
        return options;
      }

      const [startHour, startMinute] = this.StartTime.split(":").map(Number);
      const startMinutes = startHour * 60 + startMinute;
      return options.filter((time) => {
        const [hour, minute] = time.split(":").map(Number);
        return hour * 60 + minute > startMinutes;
      });
    },

    sortedReservations() {
      return this.reservations.slice().sort((a, b) =>
        (a.start ? a.start.valueOf() : 0) - (b.start ? b.start.valueOf() : 0)
      );
    },

    panelMeetings() {
      const now = this.now;
      return this.sortedReservations.filter((item) =>
        !this.isCheckedOutMeeting(item) && item.end && item.end.isAfter(now, "second")
      );
    },

    nextMeeting() {
      const now = this.now;
      return this.sortedReservations.find((item) =>
        item.start && !this.isCheckedOutMeeting(item) && now.isBefore(item.start)
      );
    },

    nextMeetingAfterCurrent() {
      const end = this.currentMeeting?.end;
      if (!end) return null;
      return this.sortedReservations.find((item) =>
        item.start && !this.isCheckedOutMeeting(item) && !item.start.isBefore(end)
      ) || null;
    },

    currentMeeting() {
      const now = this.now;
      return this.reservations.find((r) => {
        if (!r.start || !r.end) return false;
        if (this.isCheckedOutMeeting(r)) return false;
        return !now.isBefore(r.start, "second") && now.isBefore(r.end, "second");
      });
    },

    statusText() {
      if (!this.currentMeeting) {
        return "Available";
      }
      return `Occupied ${this.format(
        this.currentMeeting.start
      )} - ${this.format(this.currentMeeting.end)}`;
    },

    statusTitle() {
      return this.currentMeeting?.title ?? "";
    },

    durationDiff() {
      if (!this.StartTime || !this.EndTime){
        return 0;
      }
      const [sh, sm] = this.StartTime.split(":").map(Number);
      const [eh, em] = this.EndTime.split(":").map(Number);
      const startMinutes = sh * 60 + sm;
      const endMinutes = eh * 60 + em;
      const diff = endMinutes - startMinutes;
      return diff > 0 ? diff : 0;
    },

    durationHour() {
      return Math.floor(this.durationDiff / 60);
    },

    durationMinute() {
      return this.durationDiff % 60;
    },
  },

  methods: {
    resetActionInactivityTimer() {
      clearTimeout(this.actionInactivityTimer);
      this.actionInactivityTimer = null;

      if (this.LoadingDialog || this.bookingSubmitting ||
          (!this.CheckOutDialog && !this.ExtendDialog && !this.NewBookingDialog && !this.CheckinDialog)) {
        return;
      }

      this.actionInactivityTimer = setTimeout(() => {
        if (this.LoadingDialog || this.bookingSubmitting) {
          this.resetActionInactivityTimer();
          return;
        }

        if (this.NewBookingDialog) {
          this.NewBookingDialog = false;
          this.title = "";
          this.StartTime = "";
          this.EndTime = "";
        }
        this.CheckinDialog = false;
        this.CheckOutDialog = false;
        this.ExtendDialog = false;
        this.selectedExtend = null;
        this.ExtendStartTime = "";
        this.ExtendExpireTime = "";
      }, ACTION_INACTIVITY_TIMEOUT_MS);
    },

    getMeetingOrganizer(item) {
      if (!item) {
        return "-";
      }

      if (item.bookerEmail) {
        return item.bookerEmail;
      }

      if (
        item.isSystemBooking === false ||
        (item.isSystemBooking === null && item.isRoomPadBooking === false)
      ) {
        return (
          item.creatorName ||
          item.creatorEmail ||
          item.organizerName ||
          item.organizerEmail ||
          item.organizer ||
          "-"
        );
      }

      return item.organizer || item.organizerName || item.organizerEmail || "-";
    },

    preventPageZoomKeydown(event) {
      if (
        (event.ctrlKey || event.metaKey) &&
        ["+", "-", "=", "0"].includes(event.key)
      ) {
        event.preventDefault();
      }
    },

    preventPageZoomWheel(event) {
      if (event.ctrlKey || event.metaKey) {
        event.preventDefault();
      }
    },

    preventPagePinchZoom(event) {
      if (event.touches && event.touches.length > 1) {
        event.preventDefault();
      }
    },

    preventPageZoomGesture(event) {
      event.preventDefault();
    },

    handleMeetingVisibilityChange() {
      clearTimeout(this.meetingRefreshInterval);
      clearInterval(this.clockInterval);
      this.clockInterval = null;
      if (!document.hidden) {
        this.updateClock();
        this.clockInterval = setInterval(this.updateClock, 1000);
        this.getDataTodayMeetings(true, true);
      }
    },

    scheduleMeetingRefresh() {
      clearTimeout(this.meetingRefreshInterval);
      if (this._isDestroyed || this._isBeingDestroyed || document.hidden) return;
      const delay = this.meetingRefreshFailures
        ? Math.min(60000, 15000 * Math.pow(2, Math.min(this.meetingRefreshFailures - 1, 2)))
        : this.shouldRefreshCheckInStatus() ? 3000 : 15000;
      this.meetingRefreshInterval = setTimeout(() => this.getDataTodayMeetings(true), delay);
    },

    getDataTodayMeetings(silent = false, forceRefresh = false) {
      if (this._isDestroyed || this._isBeingDestroyed) return Promise.resolve(false);
      if (this._meetingFetchPromise) {
        if (!forceRefresh) return this._meetingFetchPromise;
        if (!this._queuedMeetingRefresh) {
          this._queuedMeetingRefresh = this._meetingFetchPromise.then(() => {
            this._queuedMeetingRefresh = null;
            return this.getDataTodayMeetings(silent);
          });
        }
        return this._queuedMeetingRefresh;
      }
      clearTimeout(this.meetingRefreshInterval);
      this._meetingFetchPromise = this.fetchTodayMeetings(silent).finally(() => {
        this._meetingFetchPromise = null;
        this.scheduleMeetingRefresh();
      });
      return this._meetingFetchPromise;
    },

    refreshMeetingsAfterMutation() {
      // Discard any response fetched before the successful mutation.
      this.meetingDataVersion += 1;
      this.meetingDataStale = true;
      return this.getDataTodayMeetings(true, true);
    },

    async fetchTodayMeetings(silent) {
      let self = this;
      const version = self.meetingDataVersion;
      self.isFetchingMeetings = true;
      if (!silent) self.meetingsLoading = true;
      try {
        const res = await axios.get(
          `${self.url}Calendar/getDataTodayMeetingsOffice365`,
          { timeout: PAD_READ_TIMEOUT_MS }
        );
        if (self._isDestroyed || self._isBeingDestroyed || version !== self.meetingDataVersion) return false;

        if (res.data.status === 0) {
          const data = res.data.data;
          if (!Array.isArray(data)) throw new Error("Invalid meeting data");
          self.reservations = data
            .filter(
              (e) =>
                (e.startDate || e.StartDate) &&
                (e.expireDate || e.ExpireDate)
            )
            .map((e) => ({
              ...e,
              id: e.id || e.ID,
              start: dayjs(e.startDate || e.StartDate),
              end: dayjs(e.expireDate || e.ExpireDate),

              time: `${dayjs(e.startDate || e.StartDate).format("HH:mm")} - ${dayjs(
                e.expireDate || e.ExpireDate
              ).format("HH:mm")}`,

              title: e.bookingName || e.BookingName || "No title",
              organizer:
                e.hostName ||
                e.HostName ||
                e.bookerEmail ||
                e.BookerEmail ||
                "-",
              bookerName: e.bookerName || e.BookerName || "",
              bookerEmail: e.bookerEmail || e.BookerEmail || "",
              organizerName: e.organizerName || e.OrganizerName || "",
              organizerEmail: e.organizerEmail || e.OrganizerEmail || "",
              creatorName: e.creatorName || e.CreatorName || "",
              creatorEmail: e.creatorEmail || e.CreatorEmail || "",
              roomPadEmail: e.roomPadEmail || e.RoomPadEmail || "",
              isRoomPadBooking:
                e.isRoomPadBooking ?? e.IsRoomPadBooking ?? null,
              isSystemBooking:
                e.isSystemBooking ?? e.IsSystemBooking ?? null,
              bookingSource: e.bookingSource || e.BookingSource || "",
              calendarSource: e.calendarSource || e.CalendarSource || "",
              checkInStatus: e.checkInStatus ?? e.CheckInStatus,
              checkOutStatus: e.checkOutStatus ?? e.CheckOutStatus,
              endStatus: e.endStatus ?? e.EndStatus,
              eventID: e.eventID || e.EventID,
            }));
          self.meetingRefreshFailures = 0;
          self.lastMeetingSyncAt = Date.now();
          self.meetingLoadError = "";
          self.meetingDataStale = false;
          self.checkRoomStatus();
          self.closeCheckinDialogIfCheckedIn();
          if (self.currentMeeting?.checkInStatus === true) {
            self.prefetchOrderMenu();
          }
          return true;
        } else {
          throw new Error(res.data.message || "Unable to load meeting data");
        }
      } catch (error) {
        if (self._isDestroyed || self._isBeingDestroyed || version !== self.meetingDataVersion) return false;
        self.meetingRefreshFailures += 1;
        self.meetingLoadError = error.code === "ECONNABORTED"
          ? "โหลดข้อมูลไม่สำเร็จภายในเวลาที่กำหนด ระบบจะลองอัปเดตใหม่"
          : error?.response?.data?.message || error?.message || "ไม่สามารถเชื่อมต่อระบบได้";
        return false;
      } finally {
        self.meetingsLoading = false;
        self.isFetchingMeetings = false;
      }
    },

    async getDataUserPad() {
      let self = this;
      self.LoadingDialog = true;
      try {
        const res = await axios.get(`${self.url}Calendar/getDataUserInPad`, { timeout: PAD_READ_TIMEOUT_MS });
        if (res.data.status === 0) {
          self.BindingData(res.data.data);
        }
      } catch (error) {
        const message =
          error?.response?.data?.message ||
          error?.message ||
          "เกิดข้อผิดพลาดในการเชื่อมต่อระบบ";

        Swal.fire({
          icon: "warning",
          width: 900,
          text: message,
        });
      } finally {
        self.LoadingDialog = false;
      }
    },

    OpenCheckinDialog(data) {
      let self = this;
      const eventID = data.eventID || "";
      const baseUrl = `${window.location.origin}${
        process.env.BASE_URL || "/"
      }`.replace(/\/+$/, "");

      self.bookingID = data.id;
      self.bookingEventID = eventID;
      self.bookingName = data.title;
      self.bookingDate = self.formatDate(data.start);
      self.bookingTime = data.time;
      self.QRData = eventID
        ? `${baseUrl}/CheckinMeeting/${encodeURIComponent(eventID)}`
        : "";
      self.CheckinDialog = true;
    },

    checkInMeeting(id) {
      let self = this;
      let temp = {
        id: id,
      };
      axios
        .post(`${self.url}Calendar/checkInMeetingOffice365ByID`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.markReservationCheckedIn(id);
            self.bookingDate = response.data.data.bookingDate;
            self.bookingTime = response.data.data.bookingTime;
            self.SuccessNewBookingDialog = true;
            self.CheckinDialog = false;
            self.clearDateCreateMeeting();
            self.refreshMeetingsAfterMutation();
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 900,
            text: error,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    shouldRefreshCheckInStatus() {
      const meeting = this.currentMeeting;
      return !!meeting && meeting.checkInStatus === false;
    },

    markReservationCheckedIn(idOrEventID) {
      this.reservations = this.reservations.map((item) => {
        if (item.id !== idOrEventID && item.eventID !== idOrEventID) {
          return item;
        }
        return {
          ...item,
          checkInStatus: true,
        };
      });
    },

    closeCheckinDialogIfCheckedIn() {
      if (!this.CheckinDialog) {
        return;
      }

      const checkedMeeting = this.reservations.find((item) => {
        const isSameMeeting =
          this.bookingEventID && item.eventID === this.bookingEventID;
        return isSameMeeting && item.checkInStatus === true;
      });

      if (checkedMeeting) {
        this.CheckinDialog = false;
      }
    },

    BindingData(data) {
      let self = this;
      self.roomName = data.roomPadDetail.name;
      self.hostName = data.userName || "";
      self.organizer = self.hostName;
    },

    format(d) {
      if (!d) return "";
      return dayjs(d).format("HH:mm");
    },

    formatDate(d) {
      if (!d) return "";
      return dayjs(d).format("DD/MM/YYYY");
    },

    // checkRoomStatus() {
    //   const now = dayjs();
    //   const currentMeeting = this.reservations.find(
    //     (r) => now.isAfter(r.start) && now.isBefore(r.end)
    //   );
    //   this.available = !currentMeeting;
    // },

    checkRoomStatus() {
      let self = this;
      const today = dayjs();
      const currentMeeting = self.reservations.find((r) =>
        today.isSame(r.start, "day")
      );
      self.available = !currentMeeting;
    },

    updateClock() {
      let self = this;
      const now = new Date();
      self.now = dayjs(now);
      const clockMinute = Math.floor(now.getTime() / 60000);
      if (self._clockMinute !== clockMinute) {
        self._clockMinute = clockMinute;
        self.time = now.toLocaleTimeString("th-TH", {
          hour: "2-digit",
          minute: "2-digit",
        });
      }

      if (self.NewBookingDialog && !self.bookingSubmitting &&
          (!self.bookingTimeReference || !self.now.isSame(self.bookingTimeReference, "minute"))) {
        self.bookingTimeReference = self.now.startOf("minute");
        self.syncBookingTimes();
      }
      const clockDate = `${now.getFullYear()}-${now.getMonth()}-${now.getDate()}`;
      if (self._clockDate !== clockDate) {
        self._clockDate = clockDate;
        self.date = now.toLocaleDateString("th-TH", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });
      }
    },

    isCurrentMeeting(item) {
      if (this.isCheckedOutMeeting(item)){
        return false;
      }
      if (!item || !item.start || !item.end){
        return false;
      }
      const now = this.now;
      return !now.isBefore(item.start, "second") && now.isBefore(item.end, "second");
    },

    isCheckedOutMeeting(item) {
      return item?.checkOutStatus === true || item?.endStatus === true;
    },

    openOrder() {
      this.prefetchOrderMenu();
      this.$router.push({
        path: "/Order",
        query: {
          eventID: this.currentMeeting?.eventID || "",
          roomName: this.roomName || "",
        },
      });
    },

    prefetchOrderMenu() {
      prefetchBeverageMenu(this.url);
    },

    openAllBooking() {
      this.$router.push("/AllBooking");
    },

    openBookingFromRoute() {
      if (this.$route.query.openBooking !== "1") {
        return;
      }

      this.$nextTick(async () => {
        await this.ReserveRoom(this.$route.query.bookingDate);
        this.$router
          .replace({
            path: "/MeetingRoomScreen",
          })
          .catch(() => {});
      });
    },

    async ReserveRoom(bookingDate = null) {
      let self = this;
      if (!self.meetingDataReady) {
        await self.getDataTodayMeetings(true, true);
        if (!self.meetingDataReady) return;
      }
      const today = dayjs().startOf("day");
      const requestedDate = dayjs(bookingDate);
      const selectedDate =
        bookingDate &&
        requestedDate.isValid() &&
        !requestedDate.isBefore(today, "day")
          ? requestedDate
          : today;

      self.StartDate = selectedDate.format("YYYY-MM-DD");
      self.EndDate = selectedDate.format("YYYY-MM-DD");
      self.bookingTimeReference = dayjs();
      self.title = "";
      if (!self.hostName) {
        await self.getDataUserPad();
      }
      if (!self.organizer) {
        self.organizer = self.hostName;
      }
      if (!self.organizer) {
        Swal.fire({
          icon: "warning",
          width: 900,
          text: "Host Name not found. Please try again.",
        });
        return;
      }
      const availableTimes = self.availableTimeOptions(self.StartDate);
      self.StartTime = availableTimes[0] || "";
      self.EndTime =
        availableTimes.length > 1
          ? availableTimes[Math.min(self.duration, availableTimes.length - 1)]
          : "";
      self.NewBookingDialog = true;
    },

    createBooking() {
      let self = this;
      if (self.bookingSubmitting || !self.meetingDataReady || self.bookingDateExpired) return;
      const meetingTitle = self.title.trim();
      if (!meetingTitle) {
        Swal.fire({
          icon: "warning",
          width: 900,
          text: "Please enter Meeting Name.",
        });
        return;
      }
      if (!self.organizer) {
        Swal.fire({
          icon: "warning",
          width: 900,
          text: "Host Name not found. Please try again.",
        });
        return;
      }
      if (!self.StartTime || !self.EndTime) {
        Swal.fire({
          icon: "warning",
          width: 900,
          text: "Please select Start Time and End Time.",
        });
        return;
      }

      const startDateTime = dayjs(`${self.StartDate}T${self.StartTime}`);
      const endDateTime = dayjs(`${self.EndDate}T${self.EndTime}`);
      if (
        !startDateTime.isValid() ||
        !endDateTime.isValid() ||
        !endDateTime.isAfter(startDateTime)
      ) {
        Swal.fire({
          icon: "warning",
          width: 900,
          text: "End Time must be later than Start Time.",
        });
        return;
      }

      if (
        dayjs(self.StartDate).isSame(dayjs(), "day") &&
        startDateTime.isBefore(dayjs(), "minute")
      ) {
        Swal.fire({
          icon: "warning",
          width: 900,
          text: "Start Time cannot be earlier than the current time.",
        });
        return;
      }
      let temp = {
        title: meetingTitle,
        organizer: self.organizer,
        startDate: self.StartDate,
        startTime: self.StartTime,
        endDate: self.EndDate,
        endTime: self.EndTime,
      };
      self.bookingSubmitting = true;
      axios
        .post(`${self.url}Calendar/createMeetingOffice365`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.bookingName = response.data.data.bookingName;
            self.bookingDate = response.data.data.bookingDate;
            self.bookingTime = response.data.data.bookingTime;
            self.SuccessNewBookingDialog = true;
            self.clearDateCreateMeeting();
            self.refreshMeetingsAfterMutation();
          } else {
            throw new Error(response.data.message || "Unable to create meeting");
          }
        })
        .catch(function (error) {
          const message =
            error?.response?.data?.message ||
            error?.message ||
            "เกิดข้อผิดพลาดในการเชื่อมต่อระบบ";

          Swal.fire({
            icon: "warning",
            width: 900,
            text: message,
          });
        })
        .finally(() => {
          self.bookingSubmitting = false;
        });
    },

    clearDateCreateMeeting() {
      let self = this;
      self.title = "";
      self.organizer = self.hostName;
      self.StartTime = "";
      self.EndTime = "";
      self.bookingTimeReference = null;
      self.NewBookingDialog = false;
      clearTimeout(self.bookingSuccessTimeout);
      self.bookingSuccessTimeout = setTimeout(() => {
        self.SuccessNewBookingDialog = false;
        self.CheckOutDialog = false;
      }, 3000);
    },

    handleLogoClick() {
      this.logoClickCount += 1;
      clearTimeout(this.logoClickTimeout);

      if (this.logoClickCount < 3) {
        this.logoClickTimeout = setTimeout(() => {
          this.logoClickCount = 0;
        }, 2000);
        return;
      }

      this.logoClickCount = 0;
      this.confirmLogout();
    },

    async confirmLogout() {
      const result = await Swal.fire({
        icon: "question",
        // title: "ออกจากระบบ",
        text: "ต้องการออกจากระบบใช่หรือไม่?",
        showCancelButton: true,
        confirmButtonText: "ตกลง",
        cancelButtonText: "ยกเลิก",
        confirmButtonColor: "#0010a3",
        reverseButtons: true,
      });

      if (!result.isConfirmed) {
        return;
      }

      await this.$store.dispatch("Logout");
      this.$router.replace("/Login").catch(() => {});
    },

    ReloadPage() {
      location.reload();
    },

    isStartTimeDisabled(date) {
      return !this.startTimeOptions.includes(dayjs(date).format("HH:mm"));
    },

    isEndTimeDisabled(date) {
      return !this.endTimeOptions.includes(dayjs(date).format("HH:mm"));
    },

    handleStartTimePickerChange(value, selectionType) {
      if (selectionType === "minute") {
        this.startTimePickerOpen = false;
      }
    },

    handleEndTimePickerChange(value, selectionType) {
      if (selectionType === "minute") {
        this.endTimePickerOpen = false;
      }
    },

    syncBookingTimes() {
      if (!this.NewBookingDialog || this.bookingSubmitting) return;
      const today = this.now.startOf("day");
      if (dayjs(this.StartDate).isBefore(today, "day")) {
        this.StartTime = "";
        this.EndTime = "";
        return;
      }
      const starts = this.availableTimeOptions(this.StartDate);
      if (!starts.includes(this.StartTime)) this.StartTime = starts[0] || "";
      const ends = this.endTimeOptions;
      if (!ends.includes(this.EndTime)) {
        this.EndTime = ends[Math.min(Math.max(this.duration - 1, 0), ends.length - 1)] || "";
      }
    },

    availableTimeOptions(selectedDate) {
      const date = dayjs(selectedDate);
      const referenceTime = this.bookingTimeReference || this.now;
      const today = referenceTime.startOf("day");

      if (!date.isValid() || date.isAfter(today, "day")) {
        return this.timeOptions;
      }

      if (date.isBefore(today, "day")) {
        return [];
      }

      const currentMinutes =
        referenceTime.hour() * 60 + referenceTime.minute();
      return this.timeOptions.filter((time) => {
        const [hour, minute] = time.split(":").map(Number);
        return hour * 60 + minute >= currentMinutes;
      });
    },

    openCheckOutDialog(data) {
      if (!data || !data.eventID) {
        Swal.fire({
          icon: "warning",
          width: 900,
          text: "Meeting data not found.",
        });
        return;
      }
      this.checkoutOtp = "";
      this.checkoutEventID = data.eventID;
      this.CheckOutDialog = true;
    },

    updateCheckoutOtp(value) {
      this.checkoutOtp = String(value || "").replace(/\D/g, "").slice(0, 6);
    },

    async endAndReleaseMeeting(data) {
      let self = this;
      if (!data || !data.eventID) {
        Swal.fire({
          icon: "warning",
          width: 900,
          text: "Meeting data not found.",
        });
        return;
      }

      const requiresOtp = data.bookingSource === "ExternalGoogleCalendar";
      const result = await Swal.fire({
        icon: "question",
        title: "End & Release",
        text: "ต้องการยกเลิก Meeting และคืนห้องใช่หรือไม่?",
        input: requiresOtp ? "password" : undefined,
        inputLabel: requiresOtp
          ? "กรอก OTP 6 หลักที่ส่งไปยังอีเมลเจ้าของ Meeting"
          : undefined,
        inputAttributes: requiresOtp
          ? {
              inputmode: "numeric",
              maxlength: "6",
              autocomplete: "off",
            }
          : undefined,
        inputValidator: requiresOtp
          ? (value) =>
              /^\d{6}$/.test(String(value || ""))
                ? undefined
                : "กรุณากรอก OTP ตัวเลข 6 หลัก"
          : undefined,
        showCancelButton: true,
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        confirmButtonColor: "#9a0003",
        reverseButtons: true,
      });

      if (!result.isConfirmed) {
        return;
      }

      const otp = requiresOtp ? String(result.value || "").trim() : "";
      if (requiresOtp && !/^\d{6}$/.test(otp)) {
        await Swal.fire({
          icon: "warning",
          title: "Invalid OTP",
          text: "กรุณากรอก OTP ตัวเลข 6 หลัก",
        });
        return;
      }

      self.LoadingDialog = true;
      try {
        const response = await axios.post(
          `${self.url}Calendar/cancelMeetingOffice365`,
          {
            eventId: data.eventID,
            otp: otp,
          }
        );

        if (response.data.status != 0) {
          throw new Error(response.data.message || "End & Release failed");
        }

        await self.refreshMeetingsAfterMutation();
        Swal.fire({
          icon: "success",
          title: "Room Released",
          showConfirmButton: false,
          timer: 1500,
        });
      } catch (error) {
        const message =
          error?.response?.data?.message ||
          error?.message ||
          "End & Release failed";

        Swal.fire({
          icon: "error",
          title: "Error...",
          width: 900,
          text: message,
        });
      } finally {
        self.LoadingDialog = false;
      }
    },

    async checkOutMeeting(data) {
      let self = this;
      if (self.LoadingDialog || !self.CheckOutDialog) return;
      if (data?.eventID !== self.checkoutEventID) return;
      if (self.checkoutRequiresOtp && !/^\d{6}$/.test(self.checkoutOtp)) return;
      if (!data || !data.eventID){
        Swal.fire({
          icon: "warning",
          width: 900,
          text: "Meeting data not found.",
        });
        return;
      }
      let temp = {
        eventID: data.eventID,
      };

      if (self.checkoutRequiresOtp) temp.otp = self.checkoutOtp;
      self.checkoutOtp = "";

      self.LoadingDialog = true;
      try {
        const response = await axios.post(
          `${self.url}Calendar/checkOutMeetingOffice365ByEventID`,
          temp
        );

        if (response.data.status == 0) {
          self.markReservationCheckedOut(data);
          self.rememberCheckoutHistory(data);
          self.CheckOutDialog = false;
          self.SuccessCheckOutDialog = true;
          await self.refreshMeetingsAfterMutation();
          clearTimeout(self.checkoutSuccessTimeout);
          self.checkoutSuccessTimeout = setTimeout(() => {
            self.SuccessCheckOutDialog = false;
          }, 3000);
        } else {
          throw new Error(response.data.message || "Check out failed");
        }
      } catch (error) {
        const message =
          error?.response?.data?.message ||
          error?.message ||
          "Check out failed";

        Swal.fire({
          icon: "error",
          title: "Error...",
          width: 900,
          text: message,
        });
      } finally {
        self.LoadingDialog = false;
      }
    },

    markReservationCheckedOut(data) {
      let self = this;
      const checkoutTime = dayjs();
      const checkoutKey = data.eventID || data.id;
      self.reservations = self.reservations.map((item) => {
        if ((item.eventID || item.id) !== checkoutKey){
          return item;
        }
        return {
          ...item,
          end: checkoutTime,
          checkOutStatus: true,
          endStatus: true,
        };
      });
    },

    rememberCheckoutHistory(data) {
      let self = this;
      const history = {
        ...data,
        end: dayjs(),
        time: `${data?.start ? self.format(data.start) : ""} - ${self.format(
          dayjs()
        )}`,
        checkOutStatus: true,
        endStatus: true,
      };
      const historyKey = history.eventID || history.id;
      self.checkoutHistories = [
        history,
        ...self.checkoutHistories.filter(
          (item) => (item.eventID || item.id) !== historyKey
        ),
      ];
    },

    openExtendDialog() {
      let self = this;
      if (!self.meetingDataReady || self.LoadingDialog || !self.currentMeeting?.eventID) return;
      self.extendEventID = self.currentMeeting.eventID;
      self.selectedExtend = null;
      self.ExtendStartTime = "";
      self.ExtendExpireTime = "";
      self.ExtendDialog = true;

      const firstAvailableExtend = self.extendOptions.find((min) =>
        self.canExtend(min)
      );
      if (firstAvailableExtend){
        self.selectExtend(firstAvailableExtend);
      }
    },

    selectExtend(min) {
      let self = this;
      if (!self.meetingDataReady || self.currentMeeting?.eventID !== self.extendEventID){
        return;
      }
      self.selectedExtend = min;
      const start = dayjs(self.currentMeeting.start);
      const end = dayjs(self.currentMeeting.end);

      self.ExtendStartTime = start.format("HH:mm");
      self.ExtendExpireTime = end.add(min, "minute").format("HH:mm");
    },

    getNextMeeting() {
      return this.nextMeetingAfterCurrent;
    },

    canExtend(min) {
      let self = this;
      if (!self.currentMeeting || !self.currentMeeting.end){
        return false;
      }
      const nextMeeting = self.getNextMeeting();
      if (!nextMeeting){
        return true;
      }
      const newEnd = dayjs(self.currentMeeting.end).add(min, "minute");
      const nextStart = dayjs(nextMeeting.start);
      return newEnd.isBefore(nextStart) || newEnd.isSame(nextStart);
    },

    async confirmExtend() {
      let self = this;
      if (self.LoadingDialog || !self.ExtendDialog) return;
      const meeting = self.currentMeeting;
      if (!self.meetingDataReady || !meeting?.end || !self.extendEventID || meeting.eventID !== self.extendEventID){
        self.ExtendDialog = false;
        Swal.fire({
          icon: "warning",
          width: 900,
          text: "ไม่พบข้อมูล Meeting สำหรับ Extend",
        });
        return;
      }

      if (!self.selectedExtend || !self.canExtend(self.selectedExtend)){
        Swal.fire({
          icon: "warning",
          width: 900,
          text: "ไม่สามารถ Extend เวลานี้ได้ เนื่องจากชนกับ Meeting ถัดไป",
        });
        return;
      }

      const newEnd = dayjs(meeting.end).add(self.selectedExtend, "minute");
      const temp = {
        eventID: self.extendEventID,
        extendMinute: self.selectedExtend,
        expireDate: newEnd.format("YYYY-MM-DDTHH:mm:ss"),
        endDate: newEnd.format("YYYY-MM-DD"),
        endTime: newEnd.format("HH:mm"),
      };

      self.LoadingDialog = true;
      try {
        const response = await axios.post(
          `${self.url}Calendar/extendMeetingOffice365ByEventID`,
          temp
        );

        if (response.data.status == 0) {
          self.ExtendDialog = false;
          self.selectedExtend = null;
          self.ExtendStartTime = "";
          self.ExtendExpireTime = "";
          await self.refreshMeetingsAfterMutation();
          Swal.fire({
            icon: "success",
            title: "Extend Successful",
            showConfirmButton: false,
            timer: 1500,
          });
        } else {
          throw new Error(response.data.message || "Extend meeting failed");
        }
      } catch (error) {
        const message =
          error?.response?.data?.message ||
          error?.message ||
          "เกิดข้อผิดพลาดในการ Extend Meeting";

        Swal.fire({
          icon: "warning",
          width: 900,
          text: message,
        });
      } finally {
        self.LoadingDialog = false;
      }
    },
  },
};
</script>
<style scoped>
.screen {
  background: url("~@/assets/backgroundroom.png");
  background-size: cover;
  background-position: left 80%;
  background-repeat: no-repeat;
  background-size: cover;
}

.left {
  position: relative;
}

.meeting-logo {
  touch-action: manipulation;
  user-select: none;
}

.current-meeting-time {
  padding-left: 15px;
  color: #0010a3;
  font-size: 85px;
  font-weight: 700;
}

.current-meeting-title {
  padding-left: 15px;
  color: #000;
  font-size: 50px;
  font-weight: 400;
  overflow-wrap: anywhere;
}

.current-meeting-organizer {
  padding-left: 15px;
  color: #00378e;
  font-size: 32px;
  font-weight: 400;
  overflow-wrap: anywhere;
}

.right {
  background: #d9d9d9a8;
  backdrop-filter: blur(10px);
}

.room {
  font-size: 64px;
  font-weight: 400;
}
.room-title {
  font-size: 60px;
  font-weight: 700;
  color: #123c84;
  letter-spacing: 1px;
  margin-top: 30px;
}

.clock {
  position: absolute;
  bottom: 10px;
}

.right-panel {
  height: 100%;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  background: rgba(165, 181, 206, 0.85);
  backdrop-filter: blur(6px);
}

.meeting-list {
  display: flex;
  flex: 1;
  min-height: 0;
  flex-direction: column;
}

.meeting-card-list {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
}

.booking-button-group {
  flex: 0 0 auto;
  margin-top: auto;
  padding-top: 12px;
}

.next-header {
  font-size: 36px;
  color: #00378e;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
}

.time-text {
  color: #0010a3;
  font-size: 40px;
  font-weight: 600;
}

.title-text {
  font-size: 24px;
  color: black;
}

.org-text {
  font-size: 20px;
  color: white;
}

.status-label {
  margin-top: 40px;
  width: 250px;
  font-weight: 400;
  height: 62px;
  border-radius: 30px;
  font-size: 32px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.status-label.unavailable {
  background: #765000;
}

.meeting-sync-alert {
  max-width: 100%;
  background: #fff8e8 !important;
  color: #684600 !important;
  overflow-wrap: anywhere;
}

.status-label.available {
  background: linear-gradient(90deg, #39c145, #00378e);
}

.status-label.occupied {
  background: linear-gradient(90deg, #c00003, #00378e);
}

.action-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.meeting-actions {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.btn-checkin {
  background: #00378e !important;
  color: white !important;
  font-size: 18px;
  width: 195px;
  border-radius: 26px;
  box-shadow: 0px 3.46px 3.46px 0px #00000040;
  text-transform: none;
}

.btn-release {
  background: #9a0003 !important;
  color: white !important;
  width: 195px;
  font-size: 18px;
  border-radius: 26px;
  box-shadow: 0px 3.46px 3.46px 0px #00000040;
  text-transform: none;
}

.btn-checkout {
  background: #00378e !important;
  color: white !important;
  font-size: 18px;
  width: 195px;
  border-radius: 26px;
  box-shadow: 0px 3.46px 3.46px 0px #00000040;
  text-transform: none;
}

.btn-extend {
  background: #ebeae9 !important;
  color: #00378e !important;
  font-size: 18px;
  width: 195px;
  border-radius: 26px;
  box-shadow: 0px 3.46px 3.46px 0px #00000040;
  text-transform: none;
}

.btn-order {
  background: #dbe9ff !important;
  color: #00378e !important;
  width: 118px;
  height: 50px;
  border-radius: 25px;
  border: 0;
  box-shadow: 0 11px 18px rgba(0, 55, 142, 0.28);
  cursor: pointer;
  padding: 0 !important;
  overflow: visible;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.order-button-row {
  margin-top: 50px;
  margin-left: 26px;
}

.order-icon-wrap {
  position: absolute;
  left: -15px;
  top: 50%;
  width: 62px;
  height: 62px;
  border-radius: 50%;
  background: #c6ddfb;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translateY(-50%);
  box-shadow: 0 13px 20px rgba(0, 41, 103, 0.22);
}

.order-text {
  display: block;
  width: 76px;
  color: #00378e;
  font-size: 22px;
  font-weight: 400;
  line-height: 50px;
  text-align: center;
}

.underline {
  width: 800px;
  max-width: 100%;
  height: 3px;
  background: #123c84;
  margin-top: 12px;
}
.clock-time {
  font-size: 88px;
  font-weight: 700;
  color: #00378e;
  line-height: 1;
}

.clock-date {
  font-size: 22px;
  color: #00378e;
  margin-top: 8px;
}
.next-title {
  font-size: 40px;
  font-weight: 600;
  color: #0d3b8f;
  display: flex;
  align-items: center;
}

.meeting-title {
  font-size: 18px;
  margin-top: 8px;
  color: #222;
}

.meeting-organizer {
  font-size: 14px;
  margin-top: 6px;
  color: #00378e;
}

.meeting-card {
  border-radius: 18px;
  padding: 20px;
  background: #ffffff80;
  border: 2px solid transparent;
  position: relative;
  transition: 0.2s;
}

.meeting-card.checked-out {
  background: rgba(255, 255, 255, 0.72);
  border-color: #c00003;
  box-shadow: 0 0 0 4px rgba(192, 0, 3, 0.08);
}

.meeting-card.active {
  background: #ffffff80 !important;
  color: white;
  box-shadow: 0px 4px 4px 0px #01378e !important;
}

.meeting-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.12), 0 6px 0 rgba(0, 55, 142, 0.25);
}

.meeting-card.checked-out:hover {
  box-shadow: 0 12px 28px rgba(192, 0, 3, 0.18), 0 6px 0 rgba(192, 0, 3, 0.2);
}

.meeting-badge {
  position: absolute;
  top: 12px;
  right: 14px;
  padding: 5px 12px;
  border-radius: 999px;
  background: #c00003;
  color: white;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
}

.meeting-time {
  font-size: 40px;
  font-weight: 700;
  color: #00378e;
}

.meeting-title {
  font-size: 24px;
  margin-top: 1px;
  color: #222;
}

.meeting-organizer {
  font-size: 20px;
  margin-top: 6px;
  color: #00378e;
}

.book-btn {
  height: 67px;
  border-radius: 28px;
  background: linear-gradient(90deg, #0d3b8f, #001b5c);
  color: white;
  font-weight: 600;
  font-size: 18px;
  text-transform: none;
}

.all-booking-btn {
  height: 56px;
  border-radius: 28px;
  background: #dbe9ff !important;
  color: #00378e !important;
  font-weight: 700;
  font-size: 18px;
  text-transform: none;
}

/* CLOCK */
.booking-clock {
  text-align: center;
  margin: 20px 0;
}

.booking-time {
  font-size: 64px;
  font-weight: 700;
  color: #0d3b8f;
}

.booking-time.future-booking-date {
  font-size: 52px;
}

.booking-date {
  font-size: 18px;
  color: #0d3b8f;
}

/* Keep booking actions accessible while the form scrolls on short screens. */
.booking-form-wrapper {
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  max-height: 90dvh;
  overflow: hidden;
}

.booking-form-wrapper .booking-container {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
}

.booking-form-wrapper .booking-actions {
  flex: 0 0 auto;
  flex-wrap: wrap;
  margin-top: 12px;
}

/* New Booking */
.booking-wrapper {
  border-radius: 28px;
  padding: 14px 40px;
  background: url("~@/assets/backgroundroom.png");
  background-size: cover;
  background-position: left bottom;
  background-repeat: no-repeat;
  background-size: cover;
}

.booking-header {
  background: #0d3b8f;
  color: white;
  text-align: center;
  padding: 12px;
  border-radius: 40px;
  font-size: 40px;
  font-weight: 800;
}

.close-btn {
  position: absolute;
  right: 10px;
  top: 6px;
  color: white;
}

.field-label {
  font-weight: 600;
  color: #0d3b8f;
  margin-bottom: 8px;
}

.pill-input input {
  text-align: center;
  font-weight: 600;
  color: #0d3b8f;
}

.booking-actions {
  display: flex;
  justify-content: flex-end;
  gap: 20px;
  margin-top: 30px;
}

.cancel-btn {
  background: #eef3fb !important;
  color: #00378e !important;
  border-radius: 30px;
  width: 180px;
  font-weight: 500;
  text-transform: none;
}

.confirm-btn {
  background: #00378e !important;
  color: white !important;
  border-radius: 30px;
  width: 180px;
  text-transform: none;
}

.checkout-panel {
  border-radius: 28px !important;
  overflow: hidden;
  background: #f7f9fc !important;
}

.checkout-header {
  min-height: 108px;
  padding: 26px 32px;
  display: flex;
  align-items: center;
  background: linear-gradient(135deg, #00378e 0%, #0f3f8c 62%, #9a0003 100%);
}

.checkout-icon {
  width: 66px;
  height: 66px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.18);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 18px;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.28);
}

.checkout-kicker {
  color: rgba(255, 255, 255, 0.82);
  font-size: 17px;
  font-weight: 500;
}

.checkout-title {
  color: white;
  font-size: 38px;
  font-weight: 800;
  line-height: 1.1;
}

.checkout-close {
  background: white !important;
}

.checkout-body {
  padding: 28px 32px 10px !important;
}

.checkout-time-strip {
  background: white;
  border-radius: 18px;
  padding: 18px 22px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 10px 28px rgba(0, 55, 142, 0.12);
}

.checkout-label {
  color: #667085;
  font-size: 14px;
  font-weight: 600;
}

.checkout-now {
  color: #00378e;
  font-size: 44px;
  font-weight: 800;
  line-height: 1;
}

.checkout-status-pill {
  background: #fff0f0;
  color: #9a0003;
  border-radius: 999px;
  padding: 10px 18px;
  font-size: 15px;
  font-weight: 700;
  white-space: nowrap;
}

.checkout-content {
  padding: 18px 0 0 !important;
}

.checkout-detail-grid {
  row-gap: 14px;
}

.checkout-detail-card {
  background: white;
  border: 1px solid #d9e2ef;
  border-radius: 18px;
  padding: 18px 20px !important;
  min-height: 116px;
}

.checkout-detail-card p {
  margin-bottom: 12px;
  color: #1d2a44;
  font-size: 18px !important;
  line-height: 1.35;
}

.checkout-detail-card p:last-child {
  margin-bottom: 0;
}

.checkout-detail-card b {
  color: #00378e !important;
}

.checkout-actions {
  padding-top: 20px;
}

.checkout-actions .v-btn {
  min-width: 180px;
  height: 54px !important;
  border-radius: 28px;
  text-transform: none;
  font-size: 17px;
  font-weight: 700;
}

.checkout-cancel-btn {
  background: #e8edf5 !important;
  color: #00378e !important;
  margin-right: 16px;
}

.checkout-confirm-btn {
  background: #9a0003 !important;
  color: white !important;
  box-shadow: 0 10px 22px rgba(154, 0, 3, 0.24) !important;
}

@media only screen and (max-width: 600px) {
  .checkout-header {
    padding: 22px;
  }

  .checkout-title {
    font-size: 32px;
  }

  .checkout-body {
    padding: 22px !important;
  }

  .checkout-time-strip {
    align-items: flex-start;
    flex-direction: column;
    gap: 14px;
  }

  .checkout-actions .v-btn {
    min-width: 0;
    width: 100%;
  }

  .checkout-cancel-btn {
    margin-right: 10px;
  }
}

.booking-container {
  max-width: 1100px;
}
.booking-pill-wrapper {
  background: white;
  border-radius: 20px;
  padding: 15px 20px;
  display: flex;
  align-items: center;
}

.booking-label {
  font-weight: 600;
  color: #0f3a8a;
  white-space: nowrap;
  font-size: 20px;
}

.booking-time-card {
  background: white;
  border-radius: 25px;
  padding: 30px;
}

.time-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  width: 100%;
  max-width: 500px;
  padding-left: 0;
}

.time-pill .v-input__control {
  background: #d7dee9;
  border-radius: 25px;
  text-align: center;
  font-size: 28px;
  font-weight: 600;
}

.duration-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 25px;
}

.duration-pill {
  background: #ebf4ff;
  padding: 12px 40px;
  border-radius: 30px;
  font-size: 20px;
  color: #0f3a8a;
  font-weight: 600;
  width: 700px;
  text-align: center;
}
.booking-actions-bar {
  margin-top: auto;
  display: flex;
  justify-content: flex-end;
  padding: 30px 60px;
  gap: 20px;
}

.booking-pill-input ::v-deep .v-input__slot {
  background: #ebf4ff !important;
  border-radius: 25px !important;
  box-shadow: none !important;
  /* padding: 0 16px !important; */
  height: 48px !important;
  min-height: 48px !important;
  max-height: 48px !important;
  display: flex;
  align-items: center;
}

.booking-pill-input ::v-deep .v-input__control {
  box-shadow: none !important;
}

.booking-pill-input ::v-deep input {
  text-align: center;
  font-weight: 600;
  font-size: 20px;
  color: #0d3b8f;
}

.booking-pill-input.v-input--is-disabled ::v-deep .v-input__slot {
  opacity: 1 !important;
}

.booking-pill-time-input ::v-deep .v-input__slot {
  background: #ebf4ff !important;
  border-radius: 25px !important;
  box-shadow: none !important;
  /* padding: 0 16px !important; */
  min-height: 42px !important;
  display: flex;
  width: 250px;
  align-items: center;
}

.booking-pill-time-input ::v-deep .v-input__control {
  box-shadow: none !important;
}

.booking-pill-time-input ::v-deep input {
  text-align: center;
  font-weight: 600;
  font-size: 20px;
  color: #0d3b8f;
}

.booking-pill-time-input ::v-deep .v-select__selections {
  position: static;
  justify-content: center !important;
  padding: 0 !important;
}

.booking-pill-time-input ::v-deep .v-select__selection {
  position: absolute;
  left: 50%;
  max-width: 100%;
  margin: 0 !important;
  color: #0d3b8f;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  transform: translateX(-50%);
  white-space: nowrap;
}

.booking-pill-time-input ::v-deep .v-select__slot {
  position: relative;
  width: 100%;
}

.booking-pill-time-input ::v-deep .v-select__selections input {
  width: 0;
  min-width: 0;
  padding: 0;
}

.booking-pill-time-input ::v-deep .v-input__append-inner {
  position: absolute;
  right: 12px;
}

.booking-pill-time-input.v-input--is-disabled ::v-deep .v-input__slot {
  opacity: 1 !important;
}

.booking-time-picker {
  flex: 1 1 360px;
  width: 360px;
  min-width: 0;
  max-width: 360px;
}

.booking-time-picker ::v-deep .mx-input-wrapper {
  width: 100%;
}

.booking-time-picker ::v-deep .booking-time-picker-input {
  box-sizing: border-box;
  width: 100%;
  height: 48px;
  min-height: 48px;
  max-height: 48px;
  padding: 0 42px;
  border: 0;
  border-radius: 25px;
  background: #ebf4ff;
  color: #0d3b8f;
  color-scheme: light;
  font-size: 22px;
  font-weight: 600;
  line-height: 48px;
  text-align: center;
  cursor: pointer;
}

.booking-time-picker ::v-deep .booking-time-picker-input:hover,
.booking-time-picker ::v-deep .booking-time-picker-input:focus {
  border: 2px solid #00378e;
  outline: 0;
}

.booking-time-picker ::v-deep .mx-icon-calendar {
  right: 14px;
  color: #00378e;
  font-size: 22px;
}

/* Success New Meeting */
.success-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.success-icon {
  width: 82px;
  height: 82px;
  background: #0f3f8c;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.success-title {
  margin-top: 22px;
  font-size: 28px;
  font-weight: 700;
  color: #0f3f8c;
}
.success-info {
  margin-top: 32px;
  background: #dfe5ee;
  border-radius: 18px;
  padding: 28px 45px;
  width: 100%;
  max-width: 420px;
}
.info-row {
  display: grid;
  grid-template-columns: 120px 20px 1fr;
  font-size: 16px;
  margin-bottom: 14px;
  color: #1d2a44;
  font-weight: 500;
}
.info-row:last-child {
  margin-bottom: 0;
}

.success-booking-wrapper {
  padding: 20px 46px;
}

.success-booking-card {
  border-radius: 24px !important;
  padding: 42px 46px 46px;
  box-shadow: 0 18px 40px rgba(0, 55, 142, 0.16) !important;
}

.success-booking-content {
  min-height: 390px;
  justify-content: center;
}

.success-booking-icon {
  width: 96px;
  height: 96px;
  box-shadow: 0 12px 26px rgba(15, 63, 140, 0.24);
}

.success-booking-title {
  margin-top: 26px;
  font-size: 34px;
  line-height: 1.18;
  text-align: center;
}

.success-booking-info {
  margin-top: 34px;
  max-width: 500px;
  padding: 30px 42px;
}

.success-booking-row {
  grid-template-columns: 130px 24px minmax(0, 1fr);
  font-size: 20px;
  margin-bottom: 18px;
}

.success-booking-row span:last-child {
  color: #00378e;
  font-weight: 700;
  text-align: right;
}

@media only screen and (max-width: 600px) {
  .success-booking-wrapper {
    padding: 14px 22px;
  }

  .success-booking-card {
    padding: 34px 24px 36px;
  }

  .success-booking-content {
    min-height: 340px;
  }

  .success-booking-title {
    font-size: 28px;
  }

  .success-booking-info {
    padding: 24px 22px;
  }

  .success-booking-row {
    grid-template-columns: 92px 18px minmax(0, 1fr);
    font-size: 17px;
  }
}

.extend-wrapper {
  padding: 50px 60px;
  border-radius: 30px;
  text-align: center;
}

.extend-icon-wrapper {
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
}

.extend-title {
  font-size: 28px;
  font-weight: 700;
  color: #0f3f8c;
}

.extend-current {
  margin-top: 10px;
  font-size: 18px;
  color: #333;
}

.extend-current span {
  font-weight: 600;
}

.extend-new {
  font-size: 18px;
  margin-top: 5px;
  color: #0f3f8c;
}

.extend-new span {
  font-weight: 700;
}

.extend-options {
  margin-top: 35px;
}

.extend-card {
  background: #ebeae9;
  border-radius: 30px;
  text-align: center;
  transition: 0.25s;
  cursor: pointer;
  height: 220px;
}

.extend-card.active {
  background: #ebeae9;
  box-shadow: 0px 5px 5px 0px #00378e;
}

.extend-number {
  font-size: 120px;
  font-weight: 800;
  color: #00378e;
}

.extend-text {
  font-size: 20px;
  color: #00378e;
  font-weight: 500;
}

.extend-actions {
  margin-top: 40px;
  display: flex;
  justify-content: center;
  gap: 35px;
}

.extend-card.disabled {
  background: #eee;
  color: #999;
  cursor: not-allowed;
  opacity: 0.6;
}

.btn-cancel {
  width: 200px;
  background: #dfe3ea;
  border-radius: 30px;
  padding: 14px 50px;
  text-transform: none;
  font-size: 16px;
  color: #00378e;
  font-weight: 600;
}

.btn-confirm {
  width: 200px;
  color: white;
  border-radius: 30px;
  padding: 14px 50px;
  text-transform: none;
  font-size: 16px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
  font-weight: 600;
}

@media only screen and (min-width: 601px) and (max-width: 1366px) {
  .meeting-main {
    padding: 28px !important;
  }

  .meeting-logo {
    max-width: 240px;
    margin-left: -1rem !important;
  }

  .room-title {
    margin-top: 20px;
    font-size: clamp(36px, 4.2vw, 54px);
    overflow-wrap: anywhere;
  }

  .underline {
    width: 100%;
  }

  .status-label {
    width: 210px;
    height: 54px;
    margin-top: 28px;
    font-size: 26px;
  }

  .current-meeting-time {
    font-size: clamp(48px, 5.2vw, 68px);
  }

  .current-meeting-title {
    font-size: clamp(30px, 3.3vw, 42px);
  }

  .current-meeting-organizer {
    font-size: clamp(22px, 2.4vw, 28px);
  }

  .right-panel {
    padding: 20px !important;
  }

  .clock-time {
    font-size: clamp(52px, 5vw, 70px);
  }

  .next-title {
    margin-top: 24px !important;
    font-size: clamp(26px, 2.4vw, 34px);
  }

  .meeting-card {
    padding: 16px;
  }

  .meeting-time {
    font-size: clamp(26px, 2.5vw, 34px);
  }

  .meeting-title {
    font-size: 20px;
    overflow-wrap: anywhere;
  }

  .meeting-organizer {
    font-size: 16px;
    overflow-wrap: anywhere;
  }

  .booking-wrapper {
    padding: 14px 24px;
  }

  .booking-header {
    font-size: 32px;
  }

  .booking-time {
    font-size: 52px;
  }

  .time-row,
  .duration-pill {
    width: 100%;
  }

  .time-row {
    padding-left: 0;
  }

  .time-row > .v-icon {
    width: 44px;
    height: 44px;
  }

  .booking-pill-time-input ::v-deep .v-input__slot {
    width: min(250px, 28vw);
  }

  .booking-actions {
    flex-wrap: wrap;
  }

  .extend-wrapper {
    padding: 32px 36px;
  }

  .extend-card {
    height: 170px;
  }

  .extend-number {
    font-size: 88px;
  }
}

@media only screen and (min-width: 960px) {
  .screen {
    height: 100vh;
    height: 100dvh;
    overflow: hidden;
  }

  .meeting-main {
    height: 100%;
    min-height: 0;
    overflow-x: hidden;
    overflow-y: auto;
    overscroll-behavior: contain;
  }

  .meeting-sidebar {
    height: 100%;
    min-height: 0;
  }
}

@media only screen and (min-width: 960px) and (max-height: 700px) {
  .meeting-main {
    padding: 20px !important;
  }

  .room-title {
    margin-top: 12px;
  }

  .status-label {
    margin-top: 18px;
  }

  .order-button-row {
    margin-top: 24px;
  }
}

@media only screen and (min-width: 601px) and (max-width: 959px) {
  .meeting-main {
    min-height: 440px;
  }

  .meeting-sidebar {
    min-height: 0;
  }

  .right-panel {
    height: auto;
    min-height: 520px;
    overflow: visible;
  }

  .meeting-list {
    display: flex;
  }

  .meeting-card-list {
    flex: none;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
    overflow: visible;
  }

  .meeting-card-list .meeting-card {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  .booking-button-group {
    padding-top: 12px;
  }

  .booking-pill-time-input ::v-deep .v-input__slot {
    width: min(360px, 55vw);
  }

}

@media (hover: none) {
  .meeting-card:hover {
    transform: none;
    box-shadow: none;
  }

  .meeting-card.active:hover {
    box-shadow: 0 4px 4px #01378e !important;
  }
}
</style>

<style>
.booking-time-picker-popup.mx-datepicker-main {
  overflow: hidden;
  border: 0;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 55, 142, 0.2);
  color: #27364d;
  font-family: Arial, sans-serif;
}

.booking-time-picker-popup .mx-time {
  width: 100%;
}

.booking-time-picker-popup .mx-time-column .mx-time-item {
  height: 40px;
  font-size: 16px;
  line-height: 40px;
}

.booking-time-picker-popup .mx-time-column .mx-time-item:hover {
  background: #ebf4ff;
  color: #00378e;
}

.booking-time-picker-popup .mx-time-column .mx-time-item.active {
  background: #00378e;
  color: #fff;
}

.booking-time-picker-popup .mx-time-column .mx-time-item.disabled {
  background: #f3f5f8;
  color: #a8b0bd;
}
</style>
